
















import {Component, Prop, Vue} from "vue-property-decorator";
import RelatedBox from "./RelatedBox.vue";
import Keyword from "./Keyword.vue";
import {bus} from "@/plugins/bus";
import {IFilm} from "@/interfaces/film.interface";

@Component({
  components: {
    RelatedBox,
    Keyword
  }
})

export default class Related extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  activeRelated = null;
  @Prop() items: IFilm[];

  clickRelated(index) {
    this.activeRelated = index;
    setTimeout(() => bus.$emit('drawPaths'));
  }
}
